export default "__VITE_ASSET__c4d808ed__"